import { pageTitleStyles as styles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

styles.titleText = {
    ...styles.titleText,
    variant: "h1",
};

styles.brandStyles = {
    logoImage: {
        css: css`
            img {
                object-fit: contain;
            }
        `,
        height: "35px",
    },
};
